"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const addToMean_1 = __importDefault(require("../utils/addToMean"));
function updateAverageScore({ averageScore, sessionsCompleted }, sessionEvent) {
    const { session } = sessionEvent;
    return (0, addToMean_1.default)(averageScore, sessionsCompleted, session.averageScore);
}
exports.default = updateAverageScore;
